"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    createMapAdvancedMarkerElement: ()=>createMapAdvancedMarkerElement
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
require("react");
const client_namespaceObject = require("react-dom/client");
const external_MapPinElement_js_namespaceObject = require("./MapPinElement.js");
const analytics_js_namespaceObject = require("../../analytics/analytics.js");
var analytics_js_default = /*#__PURE__*/ __webpack_require__.n(analytics_js_namespaceObject);
const createMapAdvancedMarkerElement = (options)=>{
    const { gMap, AdvancedMarkerElement, pinDetails } = options;
    if (!pinDetails.lat || !pinDetails.lng) return;
    const lat = Number(pinDetails.lat);
    const lng = Number(pinDetails.lng);
    if (isNaN(lat) || isNaN(lng)) return;
    const latLng = {
        lat,
        lng
    };
    const pinContainer = document.createElement('div');
    const pinReactRoot = (0, client_namespaceObject.createRoot)(pinContainer);
    try {
        let markerDOM = new AdvancedMarkerElement({
            content: pinContainer,
            map: gMap,
            position: latLng,
            gmpClickable: true
        });
        pinReactRoot.render(/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_MapPinElement_js_namespaceObject.MapPinElement, {
            ...pinDetails,
            markerDOM: markerDOM
        }));
    } catch (e) {
        analytics_js_default().logError({
            loggedFrom: 'MapPinElement',
            message: 'MAP_EVENT_ERROR',
            errorMessage: e?.message
        });
    }
};
exports.createMapAdvancedMarkerElement = __webpack_exports__.createMapAdvancedMarkerElement;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "createMapAdvancedMarkerElement"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
